import type { ApiRoute, NoQueryParams } from "../api"
import type { CreateStockVehicleExposeDocumentBody } from "./CreateStockVehicleExposeDocumentBody"
import type { OfferExposeDocumentView } from "./OfferExposeDocumentView"
import type { StockVehicleExposePathParams } from "./StockVehicleExposePathParams"

export const createStockVehicleExposeDocumentRoute: ApiRoute<
	StockVehicleExposePathParams,
	NoQueryParams,
	CreateStockVehicleExposeDocumentBody,
	OfferExposeDocumentView
> = {
	buildUrl: ({ inventoryId }) => `/vehicles/${inventoryId}/create-expose`,
	method: "post",
	path: "/vehicles/:inventoryId/create-expose",
}
